export default __webpack_public_path__ + "static/media/arrow-left-normal-icon.7b3df42f.svg";